import React, { Component, ErrorInfo, ReactNode, useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";
import { Formik, Field } from "formik";
import { DropDown } from "../../../ui/DropDown";
import { OperatingScore } from "../../../components/OperatingScore/OperatingScore";
import SummaryStatistcs from "./SummaryStatistcs";
import { IndicatorIcon } from "../../../assets/svg/IndicatorIcon";
import { TableEditIcon } from "../../../assets/svg/TableEditIcon";
import Avatar from "../../../ui/Avatar";
import numeral from "numeral";
import DateRange from "../../../ui/DateRange";
import { GetHook } from "../../../api/api";
import { INITIATIVES_URL } from "../../../api/urls";
import { useParams } from "react-router-dom";
import { get } from "../../../utils/get";
import DateRangePicker3 from "../../../ui/DateRangePicker3";
import moment from "moment";
import { AuthContext } from "../../../context/AuthContext";
import { AnyAaaaRecord } from "dns";
import { DateFilterSubject } from "../../../subjects/DateFilterSubject";
import PdfIcon from "../../../assets/svg/PdfIcon";
import FTIcon from "react-file-type-icons";
import { DropDownIcon } from "../../../assets/svg/DropDownIcon";

interface Comment {
  target_user: {
    names: string;
    avatar_url: string | null;
  };
  created_at: string;
  comment: string;
  documents: Array<{
    url: string;
    name: string;
  }>;
}

interface SummaryProps {
  title: string;
  setDateFilter?: any;
  dateFilter?: any;
  selectedScorecard: any;
  data: {
    name: string;
    target: number;
    score: number;
    weighted_score: number;
    weight: number;
    maxScore: number;
    minScore: number;
    baseLine: number;
    optimization: number;
    type: string;
    scoreType: string;
    operatingScore: number;
    actual?: string;
    comments: Comment[];
    variance?: string;
    normalised_weight?: string;
  };
  indicatorTitle?: string;
  indicatorData?: { name: string; weight: number; score: number }[];
}

const getColor = (score) => {
  switch (true) {
    case score >= 1 && score < 2:
      return "#D51067";
    case score >= 2 && score <= 3:
      return "#EDBC0C";
    case score > 3:
      return "#4BD041";
    case score >= 5:
      return "url(#grad2)";
    default:
      return "#D51067";
  }
};

class ErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: Error) {
    return { hasError: true };
  }

  componentDidError(error: Error, errorInfo: ErrorInfo) {
    console.error('Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

const SummaryView = ({
  selectedScorecard,
  title,
  data,
  indicatorData,
  indicatorTitle,
  dateFilter,
  setDateFilter,
}: SummaryProps) => {
  const params = useParams();
  const auth = useContext(AuthContext);
  const { user } = get(auth, "authState");
  const [useActive, setActiveState] = useState("inactive");
  const [setHeight, setHeightState] = useState("0px");
  const [setDisplay, setDisplayState] = useState("none");
  const [useRotate, setRotateState] = useState('0');

  const container = useRef<any>(null);


  function toggleAccordion() {
    setActiveState(useActive === "" ? "active" : "");
    setHeightState(
      useActive === "active" ? "0px" : `25rem`
    );
    setDisplayState(
      useActive === "active" ? "none" : "flex"
    );
    setRotateState(
      useActive === "active" ? '0' : '180'
    )
  }



  let urlParams = "";
  const scorecard_id = get(params, "scorecard_id")
    ? `scorecard_id=${get(params, "scorecard_id")}`
    : "";
  const perspective_id = get(params, "perspective_id")
    ? `&perspective_id=${get(params, "perspective_id")}`
    : "";
  const objective_id = get(params, "objective_id")
    ? `&objective_id=${get(params, "objective_id")}`
    : "";
  const kpi_id = get(params, "kpi_id")
    ? `&kpi_id=${get(params, "kpi_id")}`
    : "";

  const owner_id = `&owners=${get(selectedScorecard, "[0]owner_id")}`;



  const { data: initiatives, error } = GetHook(
    `${INITIATIVES_URL}?${scorecard_id}${owner_id}${perspective_id}${objective_id}${kpi_id}`
  );
  
  useEffect(() => {
    if (error) {
      console.error('Failed to fetch initiatives:', error);
      // Handle error state
    }
  }, [error]);

  console.log(selectedScorecard);
  console.log("data", data);
  return (
    <ErrorBoundary>
      <SummaryContainer>
        <StatisticsSection>
          <StatsSectionHeader>
            <Formik initialValues={{}} onSubmit={() => console.log("object")}>
              {({ values, setFieldValue }) => {
                { setDateFilter && setDateFilter(get(values, "date_range")) }
                return (
                  <>
                    <TitleText>
                      <span
                        style={{ fontSize: 12, color: "#214160", opacity: 0.4 }}
                      >
                        {title}
                      </span>
                      <span style={{ fontSize: 16 }}>{data?.name}</span>
                    </TitleText>
                    <DateRangeContainer>
                      <Field
                        name="date_range"
                        label="Time Period"
                        value={dateFilter}
                        component={DateRangePicker3}
                      />
                    </DateRangeContainer>
                  </>
                );
              }}
            </Formik>
          </StatsSectionHeader>
          <StatsContainer>
            {/* weighted score */}
            <OperatingScore
              //@ts-ignore
              score={selectedScorecard[0]?.weighted_periodic_score}
              text={true}
            />
            <SummaryStatistcs
              title={title}
              weightedScore={data?.weighted_score}
              target={data?.target}
              actual={data?.actual}
              variance={data?.variance}
              initiativesTotal={initiatives?.length || 0}
            />
          </StatsContainer>
        </StatisticsSection>
        <IndicatorsSection>
          <IndicatorsSectionHeader>
            <TitleText>{indicatorTitle || ""}</TitleText>
          </IndicatorsSectionHeader>
          <IndicatorsSectionHeader >
            <TitleText>Last comments</TitleText>
            <TitleText style={{ fontSize: 12 }}>
              See full conversation <strong />
              <span onClick={() => toggleAccordion()}
              style={{
                backgroundColor: '#ADD8E6', 
                borderRadius: '50%', 
                height: "1rem", 
                width: "1rem", 
                justifyContent: "center",
                alignItems: "center",
                display: "inline-flex" }}>
                <DropDownIcon style={{ transform: `rotate(${useRotate}deg)` }} />
              </span>
            </TitleText>

          </IndicatorsSectionHeader>
          <IndicatorsContainer>
            {indicatorData?.map((indicator) => (
              <>
                <Indicator>
                  <span style={{transition: "transform 0.3s ease;"}}>
                    <IndicatorIcon color={getColor(indicator.score)} />
                  </span>
                  <TitleText>"{indicator.name}"</TitleText>
                  <IndicatorWeight color={getColor(indicator.score)}>
                    {indicator.score}
                  </IndicatorWeight>
                </Indicator>
                <TableEditIcon />
              </>
            ))}
          </IndicatorsContainer>
            
            <MessageContainer ref={container} style={{ maxHeight: `${setHeight}`, display: `${setDisplay}`}}>
              {Array.isArray(data?.comments) ? data.comments.map((comment, index) => {
                return (
                  <MessageComponent key={index}>
                    <Avatar
                      url={
                        comment?.target_user.avatar_url ||
                        `https://ui-avatars.com/api/?name=${comment?.target_user.names}`
                      }
                    />
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        paddingLeft: "1rem",
                        width: "100%",
                      }}
                    >
                      <MessageHeader>
                        <TitleText>{comment?.target_user.names}</TitleText>
                        <h6>
                          {moment(comment.created_at).format("Do MMM YYYY LT")}
                        </h6>
                      </MessageHeader>
                      <Message
                        style={{
                          fontSize: 10,
                          fontWeight: "normal",
                          color: "#214160",
                        }}
                      >
                        {comment?.comment === "undefined" ? "No comment" : comment?.comment}
                      </Message>

                      {comment?.documents?.length ? (
                        <>
                          <TitleText style={{ fontSize: 12, opacity: 0.7 }}>
                            Attachments
                          </TitleText>
                          {comment.documents.map((doc, index) => {
                            // Skip rendering if all relevant fields are null
                            if (!doc?.name && !doc?.url && !doc?.name) {
                              return null;
                            }

                            const fileName = doc?.name || doc?.name || 'Untitled';
                            const fileUrl = doc?.url || '#';
                            
                            return (
                              <DocLink 
                                key={`${index}-${fileName}`}
                                href={fileUrl}
                                target={fileUrl !== '#' ? "_blank" : "_self"}
                                rel={fileUrl !== '#' ? "noopener noreferrer" : undefined}
                              >
                                <FTIcon 
                                  fileName={fileName}
                                  size="1.5em" 
                                />
                                <span style={{ marginLeft: '0.5em' }}>
                                  {fileName}
                                </span>
                              </DocLink>
                            );
                          })}
                        </>
                      ) : null}
                    </div>
                  </MessageComponent>
                );
              }): null}
            </MessageContainer>
          <IndicatorsSectionHeader>
            <TitleText>Indicator info</TitleText>
          </IndicatorsSectionHeader>
          <IndicatorsSectionHeader>
            <TitleText>Initiatives</TitleText>
          </IndicatorsSectionHeader>
          <InfoContainer>
            <CardItem>
              <Title>Weight</Title>
              <TitleText>{data?.weight}</TitleText>
            </CardItem>
            {title === "KPI" && (
              <>
                <CardItem>
                  <Title>Type</Title>
                  <TitleText>{data?.type}</TitleText>
                </CardItem>
                <CardItem>
                  <Title>Data Type</Title>
                  <TitleText>{data?.scoreType}</TitleText>
                </CardItem>
                <CardItem>
                  <Title>Normalised Weight</Title>
                  <TitleText>{data?.normalised_weight}</TitleText>
                </CardItem>
                <CardItem>
                  <Title>Target</Title>
                  <TitleText>{numeral(data?.target).format("0a")}</TitleText>
                </CardItem>
                <CardItem>
                  <Title>Goal</Title>
                  <TitleText>{data?.optimization}</TitleText>
                </CardItem>
              </>
            )}
          </InfoContainer>
          <InitiativesContainer>
            {initiatives.map((initiative, index) => (
              <Indicator key={index}>
                <TitleText>{get(initiative, "name")}</TitleText>
              </Indicator>
            ))}
          </InitiativesContainer>
        </IndicatorsSection>
      </SummaryContainer>
    </ErrorBoundary>
  );
};

export default SummaryView;

const SummaryContainer = styled.div`
  display: grid;
  padding-top: 1em;
`;
const StatisticsSection = styled.div`
  display: grid;
  padding: 1.5em;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 5em 1fr;
  grid-row-gap: 2em;
`;

const StatsSectionHeader = styled.div`
  display: grid;
  margin: 0 1em;
  grid-template-columns: 6fr 3fr 3fr;
  grid-column-gap: 2em;
  grid-column-start: 1;
  grid-column-end: 3;
  align-items: center;
  ${TitleText} {
    display: grid;
    margin: 0;
    padding: 0;
    color: #214160;
    font-size: 22px;
  }
`;

const IndicatorsSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 0.2fr 1fr 0.2fr 1.5fr;
`;


const IndicatorsSectionHeader = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1.5em 1em;
  align-items: center;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
  border-top: 1px solid rgba(55, 81, 255, 0.1);
  border-right: 1px solid rgba(55, 81, 255, 0.1);
  height: 2rem;
`;
//Removed:height: 30rem; , row-gap: 1em; , grid-template-rows: repeat(auto-fill, 1fr); to reduce the spaces between the indicators
const IndicatorsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.1fr;
  border-right: 1px solid rgba(55, 81, 255, 0.1);
  overflow-y: scroll;
  scrollbar-width: 0;
  &::-webkit-scrollbar {
    width: 0px;
  }
  align-items: center;
  align-self: flex-start;
`;
const InitiativesContainer = styled.div`
  border-right: 1px solid rgba(55, 81, 255, 0.1);
  height: 30rem;
  overflow: auto;
`;

const InfoContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-right: 1px solid rgba(55, 81, 255, 0.1);
  padding: 1em;
  column-gap: 1em;
  row-gap: 1em;
  height: 25rem;
  position: relative;
`;
const CardItem = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f5f6fb;
  padding: 1em;
  padding-bottom: 0;
  border-radius: 1em;
  height: 5em;
  ${TitleText} {
    font-size: 16px;
  }
`;
const Title = styled.h5`
  margin: 0;
  font-size: 0.75em;
  font-weight: 450;
  color: #214160;
  opacity: 0.5;
  margin-bottom: 1em;
`;

const Indicator = styled.span`
  background-color: #f5f6fb;
  color: #444;
  cursor: pointer;
  padding: 0.75em;
  display: flex;
  align-items: center;
  margin: 1em;
  border: none;
  border-radius: 1em;
  outline: none;
  transition: background-color 0.6s ease;
  span {
    margin-right: 1em;
  }
`;

const IndicatorWeight = styled.span`
  margin-left: auto;
  padding: 0.2em 0.5em;
  align-items: center;
  /* background: #ffe4e4; */
  color: ${(props) => props.color};
  font-weight: 600;
  border-radius: 5px;
`;

const MessageContainer = styled.div`
  flex-direction: column;
  padding: 1em;
  overflow-y: auto;
  max-height: 25rem;
  transition:  3s ease, max-height 0.5s ease;
`;

const MessageComponent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #f5f6fb;
  padding: 1em;
  border-radius: 1em;
  margin-bottom: 1em;
`;

const Message = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 1em;
  ${TitleText} {
    font-size: 12;
  }
`;

const DateRangeContainer = styled.div`
  grid-column: 2 / span 6;
`;

const DocLink = styled.a`
  padding: 0.5em;
  text-decoration: none;
  font-size: 12px;
  color: #8b9bae;
`;

const MessageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  h6 {
    padding: 0;
    margin: 0;
  }
`;


const StatsContainer = styled.div`
display: grid;
grid-template-columns: 6fr 6fr;
grid-column-gap: 1em;
grid-column-start: 1;
grid-column-end: 3;

`;